import type { Init } from '../types';

export const getDoesBodyRequireModification = (body?: Init['body']): boolean =>
  !!body && !(body instanceof FormData) && typeof body !== 'string';
